import { render, staticRenderFns } from "./AddTournamentPlaceForm.vue?vue&type=template&id=f2c0c752"
import script from "./AddTournamentPlaceForm.vue?vue&type=script&lang=js"
export * from "./AddTournamentPlaceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports